export const ROUTES = {
  EMISSAO_NFE: "/emissaonfe",
} as const;
